import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
/** @internal */
export const PortalFunction = (props) => {
    const { visibility, wrapper: Wrapper, openPortal, closePortal, hideTimeout, children, portal, } = props;
    const isOpenByVisibility = visibility.visible;
    useEffect(() => {
        if (visibility.visible) {
            openPortal();
        }
        else {
            if (hideTimeout) {
                const timeout = setTimeout(() => {
                    closePortal();
                }, hideTimeout);
                return () => {
                    clearTimeout(timeout);
                };
            }
            else {
                closePortal();
            }
        }
    }, [isOpenByVisibility, hideTimeout]);
    return portal(_jsx(Wrapper, { children: isOpenByVisibility ? children : null }));
};
export default PortalFunction;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9ydGFsRnVuY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Qb3J0YWwvY29tcG9uZW50cy9Qb3J0YWxGdW5jdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQWMsRUFBd0MsU0FBUyxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBWS9FLGdCQUFnQjtBQUNoQixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQTRCLENBQUMsS0FBSyxFQUFFLEVBQUU7SUFDL0QsTUFBTSxFQUNKLFVBQVUsRUFDVixPQUFPLEVBQUUsT0FBTyxFQUNoQixVQUFVLEVBQ1YsV0FBVyxFQUNYLFdBQVcsRUFDWCxRQUFRLEVBQ1IsTUFBTSxHQUNQLEdBQUcsS0FBSyxDQUFDO0lBRVYsTUFBTSxrQkFBa0IsR0FBRyxVQUFVLENBQUMsT0FBTyxDQUFDO0lBRTlDLFNBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDYixJQUFJLFVBQVUsQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUN2QixVQUFVLEVBQUUsQ0FBQztRQUNmLENBQUM7YUFBTSxDQUFDO1lBQ04sSUFBSSxXQUFXLEVBQUUsQ0FBQztnQkFDaEIsTUFBTSxPQUFPLEdBQUcsVUFBVSxDQUFDLEdBQUcsRUFBRTtvQkFDOUIsV0FBVyxFQUFFLENBQUM7Z0JBQ2hCLENBQUMsRUFBRSxXQUFXLENBQUMsQ0FBQztnQkFFaEIsT0FBTyxHQUFHLEVBQUU7b0JBQ1YsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO2dCQUN4QixDQUFDLENBQUM7WUFDSixDQUFDO2lCQUFNLENBQUM7Z0JBQ04sV0FBVyxFQUFFLENBQUM7WUFDaEIsQ0FBQztRQUNILENBQUM7SUFDSCxDQUFDLEVBQUUsQ0FBQyxrQkFBa0IsRUFBRSxXQUFXLENBQUMsQ0FBQyxDQUFDO0lBRXRDLE9BQU8sTUFBTSxDQUFDLEtBQUMsT0FBTyxjQUFFLGtCQUFrQixDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLElBQUksR0FBVyxDQUFDLENBQUM7QUFDM0UsQ0FBQyxDQUFDO0FBRUYsZUFBZSxjQUFjLENBQUMifQ==